module.exports = {
      id: "pre-blue-forest-usage",
      viewBox: "0 0 42 39",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#pre-blue-forest",
      toString: function () {
        return this.url;
      }
    }